(() => {
  const blocks = [...document.querySelectorAll('[data-focus-buy]')];
  const sticky = document.getElementById('lp_sticky');
  const recognition = document.querySelector('[data-sticky-after]') || document.getElementById('focus-recognition');
  const track = name => { if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() && typeof window.clarity === 'function') window.clarity('event', name); };
  const sync = input => {
    blocks.forEach(block => {
      const match = [...block.querySelectorAll('input[name="id"]')].find(item => item.value === input.value);
      if (!match || match.disabled) return;
      match.checked = true;
      block.querySelector('[data-finish-name]').textContent = match.dataset.name;
      block.querySelector('[data-focus-price]').textContent = match.dataset.price;
      if (block.gallery) block.gallery.show(match.value);
      block.querySelector('[data-focus-pdp]').href = match.dataset.url;
      block.querySelector('[type="submit"]').disabled = false;
    });
  };
  const gallery = block => {
    const root = block.querySelector('[data-focus-gallery]');
    if (!root) return null;
    const dots = root.querySelector('[data-gal-dots]');
    const tracks = [...root.querySelectorAll('[data-gal]')];
    const active = () => tracks.find(t => !t.hidden) || tracks[0];
    const index = t => Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
    const paint = () => {
      const t = active(); const i = index(t);
      [...dots.children].forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
      root.querySelector('[data-gal-prev]').disabled = i <= 0;
      root.querySelector('[data-gal-next]').disabled = i >= t.children.length - 1;
    };
    const go = (t, i) => t.scrollTo({left: i * t.clientWidth, behavior: 'smooth'});
    const build = () => {
      const t = active(); dots.textContent = '';
      [...t.children].forEach((_, i) => {
        const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', `${i + 1} / ${t.children.length}`);
        b.addEventListener('click', () => go(t, i)); dots.appendChild(b);
      });
      dots.hidden = t.children.length < 2; root.classList.toggle('is-single', t.children.length < 2); paint();
    };
    tracks.forEach(t => { let raf = 0; t.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }, {passive: true}); });
    root.querySelector('[data-gal-prev]').addEventListener('click', () => { const t = active(); go(t, Math.max(0, index(t) - 1)); });
    root.querySelector('[data-gal-next]').addEventListener('click', () => { const t = active(); go(t, Math.min(t.children.length - 1, index(t) + 1)); });
    build();
    return { show: id => { tracks.forEach(t => { t.hidden = t.dataset.gal !== id; }); const t = active(); t.scrollLeft = 0; build(); } };
  };
  blocks.forEach(block => {
    block.gallery = gallery(block);
    block.querySelectorAll('input[name="id"]').forEach(input => input.addEventListener('change', () => sync(input)));
    block.querySelector('form').addEventListener('submit', async event => {
      event.preventDefault();
      const form = event.currentTarget;
      if (form.dataset.busy === 'true') return;
      const selected = form.querySelector('input[name="id"]:checked');
      if (!selected || selected.disabled) return;
      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('[role="alert"]');
      form.dataset.busy = 'true'; button.disabled = true; button.setAttribute('aria-busy', 'true'); error.hidden = true;
      try {
        const items = [{id: Number(selected.value), quantity: 1}];
        if (window.SkoposCart) await window.SkoposCart.add(items);
        else {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
          if (!response.ok) throw new Error('cart');
          window.location.assign(root + 'cart');
        }
        track(block.id);
      } catch { error.textContent = form.dataset.error; error.hidden = false; }
      finally { delete form.dataset.busy; button.disabled = false; button.removeAttribute('aria-busy'); }
    });
  });
  function updateSticky() {
    if (!sticky || !recognition) return;
    const afterRecognition = recognition.getBoundingClientRect().bottom <= 0;
    const buying = blocks.some(block => {const rect=block.getBoundingClientRect();return rect.bottom>0 && rect.top<innerHeight;});
    const obstructed = !!document.querySelector('dialog[open],#skopos-consent:not([hidden]),#shopify-pc__banner');
    const hidden = !afterRecognition || buying || obstructed;
    sticky.classList.toggle('is-on', !hidden); sticky.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }
  let scheduled = false;
  addEventListener('scroll', () => {if (!scheduled) {scheduled=true;requestAnimationFrame(()=>{scheduled=false;updateSticky();});}}, {passive:true});
  addEventListener('resize', updateSticky);
  if (sticky) {
    sticky.querySelector('a').addEventListener('click', event => {
      event.preventDefault();
      const nearest = blocks.reduce((best,block) => Math.abs(block.getBoundingClientRect().top)<Math.abs(best.getBoundingClientRect().top)?block:best,blocks[0]);
      if (nearest) {nearest.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});nearest.querySelector('input:checked')?.focus({preventScroll:true});}
      track('lp_sticky');
    });
    new MutationObserver(updateSticky).observe(document.body,{subtree:true,attributes:true,attributeFilter:['open','hidden']});
  }
  document.querySelectorAll('#lp_hero_cta,[data-focus-pdp]').forEach(link=>link.addEventListener('click',()=>track(link.dataset.clarity)));
  const seen=new Set();
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting&&!seen.has(entry.target)){seen.add(entry.target);track(entry.target.dataset.clarity);}}),{threshold:.5});
  document.querySelectorAll('[data-clarity="lp_compare"],[data-clarity="lp_cochrane"],[data-clarity^="lp_reason_"]').forEach(el=>observer.observe(el));
  updateSticky();
})();